// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"5dc18424","562":"0c924f52"}[chunkId] + ".chunk.css";
};